import { GetAdvocateByStoryMeta, GetAdvocateByStoryPayload } from 'types/store/GetAdvocateByStory';
import { createAsyncReducer } from 'utils/Redux';

import { getAdvocateByStoryActions } from '../actions';

export default createAsyncReducer<GetAdvocateByStoryMeta, GetAdvocateByStoryPayload>(getAdvocateByStoryActions);
